// extracted by mini-css-extract-plugin
module.exports = {"form-item":"form-item__1Hwud","formItem":"form-item__1Hwud"};